export default {
    getAppConfig: state => state.appConfig,
    getMenuItems: state => state.menuItems,
    getCompanySites: state => state.companySites,
    getSelectedCompanySite: state => state.selectedCompanySite,
    getAppointmentStatus: state => state.appointmentStatus,
    getDefaultColor: state => state.defaultColor,
    getAppointmentsDate: state => state.appointmentsDate,
    isOpenChat: state => state.chat,
    isOpenAppointments: state => state.appointments,
    isOpenPatientSelect: state => state.patientSelect,
    getUnreadedMessageCount: state => state.unreadedMessageCount,
    getExternalAppointmentCount: state => state.externalAppointmentCount,
    getEnvProfile: state => state.envProfile
}
